import React from "react";
import { useNavigate } from "react-router-dom";

const Fundamental = ()=>{
const navigate = useNavigate();

const scrollToTop = (location) => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(location)
  };


return(
<div className="life-saving">


<h2 className="module-title">Training Fundamentals</h2>
<div className="fundamental-top-pic"></div>

<p className="blue-text">Training Subjects</p>
<p className="orange-bold">Life-Saving Rules</p>


<p className="reading-text">The Life-Saving Rules are an industry standard and have contributed to a significant reduction in fatal accidents. Introduction of the Life-Saving Rules in your company takes some 6 steps. 
  VIRSAT has 16 years’ experience with each of these steps. We have the required training tools and methods as well. <a href="/Contact"> Drop an email</a> to us to get started with your Life-Saving Rules roll-out or refresher campaign.  
</p>
{/* -------------------------------------------------------- */}
<p className="orange-bold">Driving Safety</p>

<p className="reading-text">Driving is big killer. On and off-duty. VIRSAT implements driver safety solutions since 2007. This is including dedicated solutions for driving in the challenging conditions of desert roads 
</p>


<p className="orange-bold">Process Safety</p>


<p className="reading-text"> 
  Think about losing much of your company assets in one big bang. It has happened to other companies, remember the Macondo well disaster in 2010? It killed 11 people and caused many billion dollars of damage. Up to now the company has not fully recovered. 
  VIRSAT has innovative Process Safety training for your operators to prevent a big bang.
</p>

<p className="orange-bold">Learning from Incidents</p>


<p className="reading-text">Many incidents have happened before. Preventing repeat incidents by learning from previous incidents is the aim of VIRSAT’s Learning from Incident training. 
</p>

{/* ----------------------------------------------------------- */}

<p className="blue-text">Training Delivery Methods</p>


<p className="orange-bold">Virtual Reality</p>

   
  
        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Driving+Aware.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/lifeSavingImages/fundamentalvr.jpg" alt="VR Training"className="fundamental-image" />
        </a>
  <p className="reading-text">
Interactive. Highly engaging and immersive Virtual Reality is increasingly used in industrial companies. VIRSAT has developed several VR training courses.</p>


<p className="orange-bold">Interactive PC 360</p>

        <a href="https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Black+Top+Driving+Pro.mp4" target="_blank" rel="noopener noreferrer">

        <img src="/lifeSavingImages/fundamental360.jpg" alt="Driving Pro Black Top"className="fundamental-image" />
        </a>
  <p className="reading-text">
  Where VR headsets are not available the same interactive training can be done on a PC. The workplace is shown in 360 degrees, as close to reality as is possible on a PC screen. </p>
  

{/* ------------------------------------------------------------------- */}

<p className="blue-text">Site Observations/Audits/Workplace Checks </p>

<p className="reading-text">
An important step in safe working is to check whether all critical items are in place to prevent incidents. VIRSAT developed a practical tool for workers in the field to observe, check and audit the work activities using ‘Headsafe’ an AI driven handsfree tool to help workers to stay safe.  </p>

<p className="blue-text">languages</p>

<p className="reading-text">VIRSAT offers training in 23 languages in spoken word and written.  
</p>

<p className="blue-text">Comparing with Class-room Training</p>

<p className="reading-text">In every way VR training beats classroom training 
</p>



<ul className="bar-margin">

    <img src = "/lifeSavingImages/bar-chart.png"  height={500} className="training-image"/>

</ul>

<a href="https://virsat.com/news/virtual-reality-driving-simulator/" target="_blank" rel="noopener noreferrer" className="external-link-button">
  Other VIRSAT Products
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 17L17 7"></path>
    <path d="M7 7h10v10"></path>
  </svg>
</a>
</div>
)
}

export default Fundamental;